<ng-container *transloco="let convert;">
  <div>
    <div class="profile-settings">
      <div class="profile-settings__header">{{convert('profileManagement.profileMobile.header')}}</div>
      <accordion>
        <accordion-group panelClass="user-contact" isDisabled="true">
          <button
            class="btn btn-link btn-block clearfix profile-settings__toggle"
            accordion-heading
            data-track-elem="accordion"
            data-track-name="Contact"
            data-track-trigger="statechange"
            [attr.data-track-state]="accordionState['user-contact']"
            (click)="clickAccordion('user-contact')"
            >
            <i class="allycon-glyph-caret-right" aria-hidden="true"></i> <span class="d-inline-block ms-1">{{convert('profileManagement.profileMobile.contact')}}</span>
          </button>
          <app-user-contact appCheckUnsavedForms (closeParentAccordion)="closeAccordion('user-contact')">
          </app-user-contact>
          @if (shouldDisplayAlertNotice()) {
            <div class="alert-i-bubble">
              <div class="alert-text">
                <p><i class="allycon-info-outline text-primary"></i> {{convert('profileManagement.profileMobile.moveAlerts')}}
                <a data-track-elem="tab" data-track-trigger="switch" data-track-name="Alerts" class="profile-nav__link"
                  href="javascript:void(0);" (click)="clickAccordion('alerts-alerts')"
                  [attr.aria-label]="convert('profileManagement.profileNav.ariaLabelManageAlert')">
                  {{convert('profileManagement.profileNav.alerts')}}
                </a>
                <button
                  class="close"
                  aria-label="Close"
                  (click)="close()">
                  <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
                </button>
              </p>
            </div>
          </div>
        }
      </accordion-group>
      @if (isEditSecurityProfileEnabled) {
        <accordion-group panelClass="change-password" isDisabled="true">
          <button
            class="btn btn-link btn-block clearfix profile-settings__toggle"
            accordion-heading
            data-track-elem="accordion"
            data-track-name="Change Password"
            data-track-trigger="statechange"
            [attr.data-track-state]="accordionState['change-password']"
            (click)="clickAccordion('change-password')"
            >
            <i class="allycon-glyph-caret-right" aria-hidden="true"></i>
            <span class="d-inline-block ms-1">{{convert('profileManagement.profileMobile.changePassword')}}</span>
          </button>
          <app-change-password appCheckUnsavedForms (closeParentAccordion)="closeAccordion('change-password')">
          </app-change-password>
        </accordion-group>
      }
    </accordion>
  </div>
  @if (!isCanadianAmbassador) {
    <div class="profile-settings">
      <div class="profile-settings__header">{{convert('profileManagement.profileMobile.dealership')}}</div>
      <accordion>
        <accordion-group panelClass="dealer-contact" class="dealer-contact-accordion" isDisabled="true">
          <button
            class="btn btn-link btn-block clearfix profile-settings__toggle"
            accordion-heading
            data-track-elem="accordion"
            data-track-name="Contact"
            data-track-trigger="statechange"
            [attr.data-track-state]="accordionState['dealer-contact']"
            (click)="clickAccordion('dealer-contact')"
            >
            <i class="allycon-glyph-caret-right" aria-hidden="true"></i> <span class="d-inline-block ms-1">{{convert('profileManagement.profileMobile.contact')}}</span>
          </button>
          <app-dealer-contact appCheckUnsavedForms (closeParentAccordion)="closeAccordion('dealer-contact')">
          </app-dealer-contact>
        </accordion-group>
        @if (dealershipBuyerLinkEnabled) {
          <accordion-group panelClass="dealer-credit" isDisabled="true">
            <button
              class="btn btn-link btn-block clearfix profile-settings__toggle"
              accordion-heading
              data-track-elem="accordion"
              data-track-name="Buyer"
              data-track-trigger="statechange"
              [attr.data-track-state]="accordionState['dealer-credit']"
              (click)="clickAccordion('dealer-credit')"
              >
              <i class="allycon-glyph-caret-right" aria-hidden="true"></i>
              <span class="d-inline-block ms-1">{{convert('profileManagement.profileMobile.buyer')}}</span>
            </button>
            <app-dealer-credit></app-dealer-credit>
          </accordion-group>
        }
        @if (dealershipSellerLinkEnabled) {
          <accordion-group panelClass="dealer-seller" isDisabled="true">
            <button
              class="btn btn-link btn-block clearfix profile-settings__toggle"
              accordion-heading
              data-track-elem="accordion"
              data-track-name="Seller"
              data-track-trigger="statechange"
              [attr.data-track-state]="accordionState['dealer-seller']"
              (click)="clickAccordion('dealer-seller')"
              >
              <i class="allycon-glyph-caret-right" aria-hidden="true"></i>
              <span class="d-inline-block ms-1">{{convert('profileManagement.profileMobile.seller')}}</span>
            </button>
            <app-dealer-seller></app-dealer-seller>
          </accordion-group>
        }
      </accordion>
    </div>
  }
  @if (isManageAlertsEnabled) {
    <div class="profile-settings">
      <div class="profile-settings__header">{{convert('profileManagement.profileMobile.manageAlerts')}}</div>
      <accordion>
        @if (isAlertsPageEnabled()) {
          <accordion-group panelClass="alerts-alerts" isDisabled="true">
            <button
              class="btn btn-link btn-block clearfix profile-settings__toggle"
              accordion-heading
              data-track-elem="accordion"
              data-track-name="Alerts"
              data-track-trigger="statechange"
              [attr.data-track-state]="accordionState['alerts-alerts']"
              (click)="clickAccordion('alerts-alerts')"
              >
              <i class="allycon-glyph-caret-right" aria-hidden="true"></i>
              <span class="d-inline-block ms-1">{{convert('profileManagement.profileMobile.alerts')}}</span>
            </button>
            <app-alerts-alerts (closeParentAccordion)="closeAccordion('alerts-alerts')"></app-alerts-alerts>
          </accordion-group>
        }
        <accordion-group panelClass="alerts-users" isDisabled="true">
          <button
            class="btn btn-link btn-block clearfix profile-settings__toggle"
            accordion-heading
            data-track-elem="accordion"
            data-track-name="Users"
            data-track-trigger="statechange"
            [attr.data-track-state]="accordionState['alerts-users']"
            (click)="clickAccordion('alerts-users')"
            >
            <i class="allycon-glyph-caret-right" aria-hidden="true"></i>
            <span class="d-inline-block ms-1">{{convert('profileManagement.profileMobile.users')}}</span>
          </button>
          <app-alerts-buyers (closeParentAccordion)="closeAccordion('alerts-users')"></app-alerts-buyers>
        </accordion-group>
        <accordion-group panelClass="alerts-sellers" isDisabled="true" class="d-none">
          <button
            class="btn btn-link btn-block clearfix profile-settings__toggle"
            accordion-heading
            data-track-elem="accordion"
            data-track-name="Sellers"
            data-track-trigger="statechange"
            [attr.data-track-state]="accordionState['alerts-sellers']"
            (click)="clickAccordion('alerts-sellers')"
            >
            <i class="allycon-glyph-caret-right" aria-hidden="true"></i>
            <span class="d-inline-block ms-1">{{convert('profileManagement.profileMobile.sellers')}}</span>
          </button>
          <app-alerts-sellers></app-alerts-sellers>
        </accordion-group>
        <accordion-group panelClass="alerts-others" isDisabled="true">
          <button
            class="btn btn-link btn-block clearfix profile-settings__toggle"
            accordion-heading
            data-track-elem="accordion"
            data-track-name="Others"
            data-track-trigger="statechange"
            [attr.data-track-state]="accordionState['alerts-others']"
            (click)="clickAccordion('alerts-others')"
            >
            <i class="allycon-glyph-caret-right" aria-hidden="true"></i>
            <span class="d-inline-block ms-1">{{convert('profileManagement.profileMobile.others')}}</span>
          </button>
          <app-alerts-others appCheckUnsavedForms (closeParentAccordion)="closeAccordion('alerts-others')">
          </app-alerts-others>
        </accordion-group>
      </accordion>
    </div>
  }

  @if (enableManageServices) {
    <div class="profile-settings">
      <div class="profile-settings__header">{{convert('profileManagement.profileMobile.manageServices')}}</div>
      <accordion>
        @if (!isCanadianTenantEnabled) {
          <accordion-group panelClass="autocheck-user-id" isDisabled="true">
            <button
              class="btn btn-link btn-block clearfix profile-settings__toggle"
              accordion-heading
              data-track-elem="accordion"
              data-track-name="AutoCheck"
              data-track-trigger="statechange"
              [attr.data-track-state]="accordionState['autocheck-user-id']"
              (click)="clickAccordion('autocheck-user-id')"
              >
              <i class="allycon-glyph-caret-right" aria-hidden="true"></i>
              <span class="d-inline-block ms-1">{{convert('profileManagement.profileMobile.autoCheck')}}</span>
            </button>
            <app-auto-check ></app-auto-check>
          </accordion-group>
        }
        <accordion-group panelClass="car-fax" isDisabled="true">
          <button
            class="btn btn-link btn-block clearfix profile-settings__toggle"
            accordion-heading
            data-track-elem="accordion"
            data-track-name="CARFAX"
            data-track-trigger="statechange"
            [attr.data-track-state]="accordionState['car-fax']"
            (click)="clickAccordion('car-fax')"
            >
            <i class="allycon-glyph-caret-right" aria-hidden="true"></i>
            <span class="d-inline-block ms-1">{{convert('profileManagement.profileMobile.carfax')}}</span>
          </button>
          <app-service-carfax ></app-service-carfax>
        </accordion-group>
      </accordion>
    </div>
  }
</div>
</ng-container>
